import React, { CSSProperties } from 'react'
import { Tag } from '@blueprintjs/core'
import { IUsageType } from '@api'
import {
  getSpaceUsageColor,
  HOT,
  HOTELING,
  PRIMARY,
  SECONDARY,
  SHARED,
  RESERVED,
  NEIGHBORHOOD,
} from '@utils/space'

interface UsageTypeTagProps {
  usageType: IUsageType
}

const colors: { [name: string]: CSSProperties } = {
  [HOT]: { color: 'white' },
  [HOTELING]: { color: 'white' },
  [PRIMARY]: { color: '#333' },
  [SECONDARY]: { color: '#333' },
  [SHARED]: { color: 'white' },
  [RESERVED]: { color: 'white' },
  [NEIGHBORHOOD]: { color: 'white' },
}

export default function UsageTypeTag({ usageType }: UsageTypeTagProps) {
  return (
    <Tag
      round
      style={{
        ...colors[usageType.name],
        background: getSpaceUsageColor(usageType),
      }}
    >
      {usageType.displayName}
    </Tag>
  )
}
